module.exports = {
	"strapLine": {
		"pt": "Soluções de <em>Contabilidade</em> & <em>Fiscalidade</em>",
		"en": "<em>Tax</em> & <em>Accounting</em> Solutions"
	},
	"contactButton": {
		"pt": "Contactar",
		"en": "Contact Us"
	},
	"nameLabel": {
		"pt": "Nome",
		"en": "Your Name"
	},
	"emailLabel": {
		"pt": "Email",
		"en": "Your Email"
	},
	"companyLabel": {
		"pt": "Empresa",
		"en": "Company"
	},
	"messageLabel": {
		"pt": "Mensagem",
		"en": "Your Message"
	},
	"cancelLabel": {
		"pt": "Cancelar",
		"en": "Cancel"
	},
	"submitLabel": {
		"pt": "Submeter",
		"en": "Submit"
	},
	"emailSent": {
		"pt": "Mensagem enviada! Obrigado.",
		"en": "We're all set. Thank you for your message!"
	},
	"emailNotSentTitle": {
		"pt": ":(",
		"en": ":("
	},
	"emailNotSentDescription": {
		"pt": "Não conseguimos entregar a sua mensagem. Tente por favor mais tarde.",
		"en": "We couldn't deliver your message. Please, try again later."
	},
	"emailBackButton": {
		"pt": "Ok",
		"en": "Ok"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/content.json
// module id = 1
// module chunks = 0